import React from 'react';

import PropTypes from 'prop-types';

import './PaymentOptionCard.css';

const PaymentOptionCardComponent = props => (
    <div className="vumareach-plan-details-payment-method"
        onClick={props.clicked.bind(this, props.option)}
        automationid={`SalesLead_Div_VPD${props.option.name}_01`}
        style={props.selected === props.option.optionName ? { borderColor: "#428600" } : null}
    >
        <div automationid={`SalesLead_P_VPD${props.option.name}00055`} className="vumareach-plan-details-payment-method-title-wrapper">
            <img src={props.option.imgIconSrc} alt=""/>
            <div automationid={`SalesLead_P_VPD${props.option.name}00012`} style={{ fontWeight: "bold" }}>{props.option.name}</div>
        </div>
        <div>
            <p style={{ lineheight: "1.3", fontFamily: "vodafonelight", color: "#999", marginTop: "0.75rem" }}>
                Plan includes:
            </p>
            {props.option.inclusions.map((item, index) => <p key={item} automationid={`SalesLead_P_VPD${props.option.name}00012${index}`} style={{ lineheight: "1.3", fontFamily: "vodafonelight", color: "#999" }}>
                - {item}
            </p>)}

        </div>
        {props.selected !== props.option.optionName &&
            <p automationid={`SalesLead_P_VPD${props.option.name}00012`} style={{ marginTop: "auto" }}><button>Select</button></p>
        }
        {props.selected === props.option.optionName && <div className="vumareach-plan-details-payment-method-selectionMark"
            automationid={`SalesLead_Div_VPD${props.option.name}00012`}><span>&#10003;</span></div>}
    </div>
);

PaymentOptionCardComponent.propTypes = {
    clicked: PropTypes.func.isRequired,
    option: PropTypes.shape({
        name: PropTypes.string,
        inclusions: PropTypes.arrayOf(PropTypes.string),
        optionName: PropTypes.string,
        imgIconSrc: PropTypes.string
    }),
    selected: PropTypes.string,
    optionName: PropTypes.string,
};

export const PaymentOptionCard = PaymentOptionCardComponent;
